import { useSelector } from '@xstate/react'
import { useClubMachine } from 'state'

export const useClubMachineState = () => {
  const machine = useClubMachine()
  const state = useSelector(machine, (state) => state)

  return { machine, state }
}
